/**
 * Telemetry Module Exports
 * 
 * Re-exports all telemetry utilities for easy importing throughout the app.
 */

export { 
  reactPlugin, 
  appInsights, 
  trackEvent,
  trackPageView,
  trackException,
  trackMetric,
  trackTrace,
  startTrackEvent,
  flushTelemetry,
  getUserInfo,
  getLastTraceparent
} from './appInsights';

export { default as TelemetryProvider } from './TelemetryProvider';

// Re-export hooks from the React plugin for convenience
export { 
  useAppInsightsContext, 
  useTrackEvent, 
  useTrackMetric,
  withAITracking 
} from '@microsoft/applicationinsights-react-js';

// Custom telemetry hooks for LaserBros-specific scenarios
export {
  useAuthTracking,
  useQuoteTracking,
  useOrderTracking,
  useFileTracking,
  usePaymentTracking,
  useSearchTracking,
  useComponentPerformance,
  useApiTracking,
  useMaterialTracking
} from './useTelemetry';

